/* eslint-disable */

import React, {lazy} from 'react'
import './App.css'
import {ConfigProvider} from 'antd'
import {QueryClient, QueryClientProvider} from 'react-query'
import koKR from 'antd/es/locale/ko_KR'
import {RecoilRoot} from 'recoil'

const DefaultRoutes = lazy(() => import('./routes'))

ConfigProvider.config({
  theme: {
    primaryColor: '#84c3bb' //'process.env.REACT_APP_THEME_COLOR',
  }
})

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnMount: true,
      refetchOnReconnect: false
    }
  }
})

function App() {
  return (
    <RecoilRoot>
      <ConfigProvider locale={koKR}>
        <QueryClientProvider client={queryClient}>
          <DefaultRoutes />
        </QueryClientProvider>
      </ConfigProvider>
    </RecoilRoot>
  )
}

export default App
